import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=d6b38d90&scoped=true"
import script from "./SectionHeader.vue?vue&type=script&lang=js"
export * from "./SectionHeader.vue?vue&type=script&lang=js"
import "./SectionHeader.vue?vue&type=style&index=0&id=d6b38d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b38d90",
  null
  
)

export default component.exports